export type RegistrationIntroTrigger = 'none' | 'onboarding' | 'preview';

export const REGISTRATION_INTRO_PREVIEW_KEY = 'aeoll.registration-intro.preview.v1';
export const REGISTRATION_INTRO_PREVIEW_PARAM = 'aeoll_intro_preview';
export const REGISTRATION_INTRO_ACTIVE_CLASS = 'aeoll-registration-intro-active';

export const REGISTRATION_INTRO_DESKTOP_ASSET =
	'/static/aeoll/registration-intro/intro-aeoll-web.webm';
export const REGISTRATION_INTRO_MOBILE_ASSET =
	'/static/aeoll/registration-intro/intro-aeoll-mob.webm';

export const REGISTRATION_INTRO_DEFAULT_TIMEOUT_MS = 7_000;
export const REGISTRATION_INTRO_TIMEOUT_GRACE_MS = 1_200;
export const REGISTRATION_INTRO_FADE_MS = 0;

export const REGISTRATION_INTRO_ONBOARDING_PATHS = ['/onboarding', '/onboarding1'] as const;

export const isRegistrationIntroOnboardingPath = (pathname: string) =>
	(REGISTRATION_INTRO_ONBOARDING_PATHS as readonly string[]).includes(pathname);

export type RegistrationIntroPreviewDirective = 'enable' | 'disable' | 'unchanged';

export const getRegistrationIntroPreviewDirective = (
	search: string
): RegistrationIntroPreviewDirective => {
	const value = new URLSearchParams(search).get(REGISTRATION_INTRO_PREVIEW_PARAM);
	if (value === '1') return 'enable';
	if (value === '0') return 'disable';
	return 'unchanged';
};

export const resolveRegistrationIntroTrigger = ({
	search,
	pathname,
	authenticated,
	onboardingIncomplete,
	previewSession
}: {
	search: string;
	pathname: string;
	authenticated: boolean;
	onboardingIncomplete: boolean;
	previewSession: boolean;
}): RegistrationIntroTrigger => {
	const previewDirective = getRegistrationIntroPreviewDirective(search);
	const previewEnabled =
		previewDirective === 'enable' || (previewDirective === 'unchanged' && previewSession);
	const onboardingDestination = authenticated && isRegistrationIntroOnboardingPath(pathname);

	if (previewEnabled && onboardingDestination) return 'preview';
	if (onboardingIncomplete && onboardingDestination) return 'onboarding';
	return 'none';
};

export const selectRegistrationIntroAsset = ({
	viewportWidth,
	viewportHeight
}: {
	viewportWidth: number;
	viewportHeight: number;
}) =>
	viewportWidth <= 767 || viewportHeight > viewportWidth
		? REGISTRATION_INTRO_MOBILE_ASSET
		: REGISTRATION_INTRO_DESKTOP_ASSET;

export const getRegistrationIntroTimeoutMs = (durationSeconds: number) => {
	if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
		return REGISTRATION_INTRO_DEFAULT_TIMEOUT_MS;
	}

	return Math.min(
		12_000,
		Math.max(
			REGISTRATION_INTRO_DEFAULT_TIMEOUT_MS,
			Math.ceil(durationSeconds * 1_000) + REGISTRATION_INTRO_TIMEOUT_GRACE_MS
		)
	);
};
